module.exports = __webpack_public_path__ + "img/binghatti.4ebfa0b.webp";